import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { ApiFragment } from '../../record/entities/api-fragment.entity';
import { PaginatedResults } from '../../record/entities/pagination/paginated-results.entity';

import { OverviewPageCache, OverviewPageCacheState, PageCache, RecordPageLookup } from './overview-page-cache.entity';
import {
    AddPageToCache,
    InitializePageCache,
    OverviewOptionsActionTypes,
    OverviewPageCacheAction
} from './overview-page-cache.actions';

export const overviewPageCacheAdapter: EntityAdapter<OverviewPageCache> = createEntityAdapter<OverviewPageCache>({
    selectId: viewOptions => viewOptions.overviewId
});
export const emptyViewOptionsState: OverviewPageCacheState = overviewPageCacheAdapter.getInitialState();

export function overviewPageCacheReducer(state = emptyViewOptionsState, action: Action): OverviewPageCacheState {
    const viewOptionsAction: OverviewPageCacheAction = action as OverviewPageCacheAction;
    switch (viewOptionsAction.type) {
        case OverviewOptionsActionTypes.InitializePageCache: {
            const newPageLookup = mapPageToRecordPageLookup(viewOptionsAction.index, viewOptionsAction.page);
            const newPageCache = mapPageToPageCache(viewOptionsAction.page);
            return overviewPageCacheAdapter.upsertOne(
                { overviewId: viewOptionsAction.overview, recordsPageLookup: newPageLookup, pageCache: newPageCache },
                state
            );
        }

        case OverviewOptionsActionTypes.AddPageToCache: {
            const pageLookup = getPageLookup(viewOptionsAction, state);
            const pageCache = getPageCache(viewOptionsAction, state);
            return overviewPageCacheAdapter.upsertOne(
                { overviewId: viewOptionsAction.overview, recordsPageLookup: pageLookup, pageCache },
                state
            );
        }

        default: {
            return state;
        }
    }
}

function mapPageToRecordPageLookup(index: number, page: PaginatedResults<ApiFragment>): RecordPageLookup {
    const newPageLookup: RecordPageLookup = {};
    for (let i = 0; i < page.results.length; i++) {
        const recordId = page.results[i].getRecordId();
        newPageLookup[recordId] = {
            page: index,
            indexInPage: i
        };
    }
    return newPageLookup;
}

function mapPageToPageCache(page: PaginatedResults<ApiFragment>): PageCache {
    return {
        [page.paginationInfo.page]: page
    };
}

function getPageLookup(action: AddPageToCache, state: OverviewPageCacheState): RecordPageLookup {
    const newPageLookup = mapPageToRecordPageLookup(action.index, action.page);
    return {
        ...state.entities[action.overview]?.recordsPageLookup,
        ...newPageLookup
    };
}

function getPageCache(action: AddPageToCache | InitializePageCache, state: OverviewPageCacheState): PageCache {
    return {
        ...state.entities[action.overview]?.pageCache,
        ...mapPageToPageCache(action.page)
    };
}
